import React from "react";
import landingPageVideo from '../assets/video/bond-video.mp4'

import { useNavigate } from "react-router-dom";


const Video = () => {
  const navigate = useNavigate();
  const videoRef = React.useRef(null)
  React.useEffect(() => {
    if (videoRef?.current) {
      videoRef?.current?.play()
    }
  })
  return (
    <>
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          height: "100%"
        }}>
        <div
          style={{
            position: "absolute",
            zIndex: "0"
          }}>
          <video className="VideoSection" ref={videoRef} src={landingPageVideo} loop playsInline muted style={{
            minHeight: "100vh",
            width: "100vw",
            objectFit: "cover",
            overflow: "hidden",
            bottom: 0,
            right: 0,
            zIndex: "1"
          }}
          ></video>
        </div>
        <div
          className="video-container-height"
          style={{
            height: "766px",
            width: "100%",
            background: "#9F9F9F",
            display: "grid",
            placeItems: "center",
            zIndex: "2"
          }}
        >

          <div
            style={{
              textAlign: "center",
              zIndex: "2"
            }}
          >
            <img className="viedioImage" src="../images/Bond.png"></img>
            <div
              className="viedioText"
              style={{
                fontSize: "40px",
                color: "white",
                marginTop: "20px",
                zIndex: "2"
              }}
            >
              Escape the Ordinary.
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "2"
              }}
            >
              <div
                className="videoButton"
                onClick={() => {
                  navigate("/contact");
                }}
                style={{
                  width: "330px",
                  padding: "10px 20px",
                  fontSize: "24px",
                  color: "white",
                  marginTop: "40px",
                  border: "2px solid white",
                  borderRadius: "56px",
                  cursor: "pointer",
                  userSelect: "none",
                  zIndex: "2"
                }}
              >
                Join Waiting List
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;
